import { Checkbox, FormControlLabel, FormGroup, makeStyles } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo } from 'react';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckboxDefaultIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import EventLabel from '../../components/EventLabel/EventLabel';

interface IUnregisterProps {
  orders: any[];
  activePersonNo: number;
  updateOrderRow: any;
  ordersLoaded: boolean;
  environment: any;
  settings: any;
  breakouts: any[];
  mainEvent: any;
}

const useStyles = makeStyles(theme => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    marginLeft: 0,
    marginRight: 0,
  },
  label: {
    '&.Mui-disabled': {
      color: 'inherit !important',
    },
    color: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit',
    fontFamily: 'inherit',
  },
}));

function Unregister(props: IUnregisterProps) {
  const { orders, activePersonNo, updateOrderRow, ordersLoaded, environment, settings, mainEvent, breakouts } = props;
  const { allowAll, selection = [], useSelection = false } = settings;

  const classes = useStyles();
  const orderRows = orders?.[activePersonNo]?.orderRow?.filter((row: any) => row.orderRowId > 0 && row.status !== 'Waitlist');

  const isCancelled = useMemo(() => {
    const order = orders?.[activePersonNo];
    const mainEventRow = orders?.[activePersonNo]?.orderRow.find((row: any) => row.eventId === environment.eventId);
    return order && mainEventRow && mainEventRow.status === 'Cancelled';
  }, [orders, activePersonNo, environment.eventId]);

  useEffect(() => {
    if (ordersLoaded && !isCancelled && !allowAll) {
      orders?.[activePersonNo]?.orderRow.forEach((row: any) => {
        row.status = 'Cancelled';
        updateOrderRow(row);
      });
    }
  }, [ordersLoaded, isCancelled, orders, updateOrderRow, activePersonNo, allowAll]);

  const handleChange = (checked: boolean, eventId: number) => {
    const orderRow = orderRows?.find((row: any) => row.eventId === eventId);
    // if (orderRow.activeEditing === undefined && orderRow.status === 'Cancelled') return;
    if (orderRow) {
      orderRow.status = checked ? 'Cancelled' : 'Confirmed';
      orderRow.activeEditing = true;
      updateOrderRow(orderRow);
    }
  };

  if (!allowAll) return null;
  return (
    <div className="w-full cms-field">
      <div className="w-full mb-4">
        <label className={'mr-2'}>
          <EventLabel name="UnregisterModule" groupName="CMS.Unregister" />
        </label>
        <p className="mt-1 text-muted">
          <EventLabel name="UnregisterModuleDescription" groupName="CMS.Unregister" />
        </p>
      </div>
      <FormGroup className={`checkbox-group `}>
        {orderRows?.map((orow: any) => (
          <div className="flex gap-x-2 items-center">
            <div className="w-32">
              <button
                onClick={(e: any) => handleChange(orow.status !== 'Cancelled', orow.eventId)}
                className="cms-button my-2 mr-4  w-fit px-1"
                style={{
                  opacity: orow.activeEditing === undefined && orow.status === 'Cancelled' ? 0.3 : 1,
                  backgroundColor: orow.status === 'Cancelled' ? 'gainsboro' : '#d70000',
                  color: orow.status === 'Cancelled' ? '#333' : 'white',
                }}
              >
                {orow.status !== 'Cancelled' ? (
                  <EventLabel name="Unregister" groupName="CMS.Unregister" />
                ) : (
                  <EventLabel name="Cancel" groupName="CMS.Unregister" />
                )}
              </button>
            </div>

            <span className={orow.status === 'Cancelled' ? 'line-through' : ''}>{[...breakouts, mainEvent]?.find(b => b.eventId === orow.eventId)?.name}</span>
          </div>
        ))}
      </FormGroup>
    </div>
  );
}

export default Unregister;
